import { Help } from '@mui/icons-material'
import {
  Stack,
  StackProps,
  SvgIconProps,
  Tooltip,
  TooltipProps,
} from '@mui/material'

const ContentWithTooltip: React.FC<
  React.PropsWithChildren<{
    title: TooltipProps['title']
    placement?: TooltipProps['placement']
    iconPosition?: 'start' | 'end'

    slotProps?: {
      tooltip?: TooltipProps
      stack?: StackProps
      icon?: SvgIconProps
    }
  }>
> = (props) => {
  const iconPosition = props.iconPosition || 'end'

  const icon = (
    <Tooltip
      {...props.slotProps?.tooltip}
      title={props.title}
      placement={props.placement}
    >
      <Help color="action" fontSize="small" {...props.slotProps?.icon} />
    </Tooltip>
  )

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      {...props.slotProps?.stack}
    >
      {iconPosition === 'start' ? icon : undefined}
      {props.children}
      {iconPosition === 'end' ? icon : undefined}
    </Stack>
  )
}

export default ContentWithTooltip
